<template>
    <v-container fill-height fluid grid-list-xl>
        <v-layout justify-center wrap>
            <v-flex md12>
                <material-card>
                    <models-universidades-table
                        :universidades="universidades"
                        v-on:update:pais="changePais($event)"
                        v-if="universidades"
                    ></models-universidades-table>
                </material-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import Vue from "vue"
import { UniversidadesService } from "../../services/carreras-api.service"

export default Vue.extend({
    data: () => ({
        universidades: [],
        pais: ""
    }),
    methods: {
        fetchUniversidades() {
            const params = {
                include: "[sede?:[lugar:[pais]],universidadCampoExtras?:[campoExtra]]"
            }

            if (this.pais) {
                params.pais = {
                    pais: this.pais
                }
                params.include = params.include.replace("sede?", "sede")
            }

            UniversidadesService.where(params).then(universidades => {
                this.universidades = universidades
            })
        },
        changePais(pais) {
            this.pais = pais
            this.fetchUniversidades()
        }
    },
    created() {
        this.fetchUniversidades()
    }
})
</script>
